import React, { useEffect, useState } from "react";
import wpHttp from "../../wpApi";
import s from "./index.module.scss";

export const CoBrandingLogo = () => {
    const [coBrandingLogoInfo, setCoBrandingLogo] = useState(null);

    const loadCoBrandingLogo = async () => {
        try {
            const response = await wpHttp.get(
                `/wp-json/acf/v3/options/options/door_co_branding_logo`
            );
            if (
                response.data.door_co_branding_logo
            ) {
                setCoBrandingLogo(response.data.door_co_branding_logo);
            } else {
                console.log("Can't reach door co-branding logo.");
            }
        } catch (error) {
            // do nothing, the co-branding logo won't show.
        }
    };
    useEffect(() => {
        loadCoBrandingLogo();
    }, []);

    return coBrandingLogoInfo ? (
        <React.Fragment>
            {coBrandingLogoInfo.url ? (
                <img className={s.image} alt={coBrandingLogoInfo.title} src={coBrandingLogoInfo.url} />
            ) : null}
        </React.Fragment>
    ) : null;
};